// extracted by mini-css-extract-plugin
module.exports = {"container":"entities_card_body-module__container--39-pV","linkcontainer":"entities_card_body-module__linkcontainer--3nO2B"};